import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface ReturnItem {
  id: string;
  orderNumber: string;
  reason: string;
  status: string;
  createdAt: string;
}

const returnStatusLabels: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Pendente', color: 'bg-gray-100 text-gray-700' },
  APPROVED: { label: 'Aprovada', color: 'bg-green-100 text-green-700' },
  REJECTED: { label: 'Rejeitada', color: 'bg-red-100 text-red-700' },
  IN_TRANSIT: { label: 'Em Transito', color: 'bg-yellow-100 text-yellow-700' },
  RECEIVED: { label: 'Recebida', color: 'bg-blue-100 text-blue-700' },
  REFUNDED: { label: 'Reembolsada', color: 'bg-purple-100 text-purple-700' },
};

export default function ReturnsPage() {
  const [returns, setReturns] = useState<ReturnItem[]>([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    api.get('/returns').then((r) => {
      setReturns(r.data.data || r.data);
      setLoadingData(false);
    });
  }, []);

  return loadingData ? (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
    </div>
  ) : (
    <div className="bg-white rounded-xl shadow-sm border border-dark-100 overflow-hidden">
      <table className="w-full">
        <thead className="bg-dark-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Pedido</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Motivo</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Data</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-dark-100">
          {returns.map((item, index) => (
            <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-dark-50/50'}>
              <td className="px-6 py-4 text-sm font-medium text-primary-600">{item.orderNumber}</td>
              <td className="px-6 py-4 text-sm text-dark-600">{item.reason || '-'}</td>
              <td className="px-6 py-4">
                <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${returnStatusLabels[item.status]?.color || 'bg-gray-100 text-gray-700'}`}>
                  {returnStatusLabels[item.status]?.label || item.status}
                </span>
              </td>
              <td className="px-6 py-4 text-sm text-dark-500">
                {new Date(item.createdAt).toLocaleDateString('pt-BR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {returns.length === 0 && (
        <div className="text-center py-12 text-dark-500">Nenhuma devolucao encontrada</div>
      )}
    </div>
  );
}
